var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable camelcase */
import * as React from 'react';
import { Text } from '@doordash/design-language';
import ButtonGroupModalFooter from './button_group_modal_footer';
import { useInviteTeamMembersAndAddToGroupByEmailMutation } from '../useInviteTeamMembersAndAddToGroupByEmailMutation';
import BulkAddToMemberStrings from './BulkAddToMemberStrings';
import track from '../../../utils/track';
import { GroupsMembersEvents } from '../../../constants/events';
import TeamAccountMemberLimitReachedBanner from '../../Common/TeamAccountMemberLimitReached/TeamAccountMemberLimitReachedBanner';
var strings = BulkAddToMemberStrings.confirmAddEmailsToTeamAndGroup;
export var ConfirmAddEmailsToTeamAccountAndGroup = function (_a) {
    var setTitle = _a.setTitle, teamAccount = _a.teamAccount, teamAccountPlanMembersInfo = _a.teamAccountPlanMembersInfo, group = _a.group, emails = _a.emails, onDoNotAdd = _a.onDoNotAdd, onAddComplete = _a.onAddComplete;
    var _b = __read(React.useState(false), 2), showMemberLimitExceeded = _b[0], setShowMemberLimitExceeded = _b[1]; // although we can calculate that limit will be exceeded if admins ADD, we want them to click button first before showing limit exceed state
    var _c = __read(useInviteTeamMembersAndAddToGroupByEmailMutation(teamAccount.id, group.id, emails, {
        onCompleted: function (response) {
            track(GroupsMembersEvents.ADD_MODAL_INVITE_CLICK, {
                group_id: group.id,
                group_name: group.name,
                email_count: emails.length,
            });
            onAddComplete(response === null || response === void 0 ? void 0 : response.inviteTeamMembersAndAddToGroupByEmail);
        },
    }), 2), inviteTeamMemberAndAddToGroup = _c[0], isLoading = _c[1].loading;
    React.useEffect(function () {
        if (setTitle && emails) {
            setTitle(emails.length > 1
                ? strings.title.multipleNotExisting(emails.length)
                : strings.title.singleNotExisting());
        }
    }, [setTitle, emails]);
    var handleAddClick = function () {
        // check team account number of members limit
        var totalMembersCount = teamAccountPlanMembersInfo.totalMembersCount, maxMembersLimit = teamAccountPlanMembersInfo.maxMembersLimit;
        if (!!maxMembersLimit &&
            totalMembersCount + emails.length > maxMembersLimit) {
            // if account has a limit and that limit will be exceeded when new members are invited show limit exceed state
            setShowMemberLimitExceeded(true);
            return;
        }
        inviteTeamMemberAndAddToGroup();
    };
    var handleDoNotAddClick = function () {
        track(GroupsMembersEvents.ADD_MODAL_DO_NOT_INVITE_CLICK, {
            group_id: group.id,
            group_name: group.name,
            email_count: emails.length,
        });
        onDoNotAdd();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { styles: Text.Styles.Body1 }, emails.length > 1
            ? strings.bodyText.multipleAdd(emails.length, teamAccount.name, group.name)
            : strings.bodyText.singleAdd(teamAccount.name, group.name)),
        React.createElement("ul", null, emails.map(function (email) { return (React.createElement("li", { key: email },
            React.createElement(Text, { styles: Text.Styles.Body1 }, email))); })),
        showMemberLimitExceeded && (React.createElement(TeamAccountMemberLimitReachedBanner, { remainingTeamMemberSlots: teamAccountPlanMembersInfo.maxMembersLimit -
                teamAccountPlanMembersInfo.totalMembersCount, teamAccountId: teamAccount.id })),
        React.createElement(ButtonGroupModalFooter, { secondary: {
                action: handleDoNotAddClick,
                text: strings.button.secondaryText(),
            }, primary: {
                action: handleAddClick,
                text: strings.button.primaryText(),
                loading: isLoading,
                disabled: showMemberLimitExceeded,
            } })));
};
